export default {
  campaignReportList: {
    url: '/campaignReport/list',
    method: 'post',
    desc: '广告报表广告活动数据'
  },
  campaignReportDetail: {
    url: '/campaignReport/detail',
    method: 'post',
    desc: '广告报表明细数据'
  },
  campaignReportAnalysis: {
    url: '/campaignReport/analysis',
    method: 'post',
    desc: '广告报表-分析明细数据'
  },
}
